module.exports = __webpack_public_path__ + "static/media/splash_mobile.532af2e0.png";